<!-- 消息提示 -->
<template>
    <div class="messageTips">
        <div class="tips-font">
            <i v-if="qffMessage.type === 'success'" class="successIcon"></i>
            <i v-else-if="qffMessage.type === 'warning'" class="warningIcon"></i>
            <i v-else-if="qffMessage.type === 'none'" class="noneIcon"></i>
            <span>{{ qffMessage.message }}</span>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {}
    },
    props: {
        qffMessage: {
            type: Object,
            default: () => {
                return {
                    type: '',
                    message: '',
                }
            },
        },
    },
}
</script>
<style scoped lang="scss">
.messageTips {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 99999999;

    height: 48px;
    padding: 0 21px 0 21px;
    border-radius: 4px 4px 4px 4px;
    background: rgba(51, 53, 68, 0.7);

    .tips-font {
        width: 100%;
        height: 48px;
        display: flex;
        align-items: center;

        span {
            font-size: 14px;
            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
            line-height: 22px;
        }

        .successIcon {
            width: 24px;
            height: 24px;
            margin-right: 7px;
            background: url('@/assets/image/userCenter/qffMessageSuccess.png');
            background-size: 100% 100%;
        }

        .warningIcon {
            width: 24px;
            height: 24px;
            margin-right: 7px;
            background: url('@/assets/image/userCenter/qffMessageWarring.png');
            background-size: 100% 100%;
        }
    }
}
</style>
